<div class="vsp-header">
    <div>
        <div class="vsp-title">Your site is live</div>
        <div class="vsp-subtitle">Share this link or connect a custom domain.</div>
    </div>
    <div class="vsp-close" (click)="closePopup()">
        <mat-icon>close</mat-icon>
    </div>
</div>

<div class="vsp-section">
    <div class="vsp-url-row">
        <mat-icon class="vsp-url-row__icon">lock</mat-icon>
        <span class="vsp-url-row__text">{{ siteUrl }}</span>
        <button class="vsp-copy-btn" (click)="copyUrl()">{{ copied ? 'Copied' : 'Copy' }}</button>
    </div>
</div>

<div class="vsp-promo">
    <div class="vsp-promo__icon">
        <mat-icon>star</mat-icon>
    </div>
    <div>
        <div class="vsp-promo__title">Get a professional domain</div>
        <div class="vsp-promo__desc">Upgrade for a custom domain, automated SEO, and analytics.</div>
    </div>
</div>

<div class="vsp-footer">
    <button class="vsp-btn vsp-btn--outline" (click)="upgradePlan()">View plans</button>
    <button class="vsp-btn vsp-btn--solid" (click)="viewPerview()">View site</button>
</div>
